export default {"src":"/_next/static/media/submit-application.d1dcb0d9.svg","height":613,"width":720};